// IndicadoresLineChart.jsx
import React, { useRef, useEffect } from 'react';
import { Chart, registerables } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(...registerables, ChartDataLabels);

const meses = [
    "dato_inicial", "m1", "m2", "m3", "m4", "m5", "m6", "m7", "m8", "m9", "m10"
];
const etiquetasMeses = [
    "Dato Inicial", "Mes 1", "Mes 2", "Mes 3", "Mes 4",
    "Mes 5", "Mes 6", "Mes 7", "Mes 8", "Mes 9", "Mes 10"
];

const IndicadoresLineChart = ({ data }) => {
    const chartRef = useRef(null);
    const myChartRef = useRef(null);

    // 1️⃣ Verificar si hay al menos un dato válido en los indicadores filtrados
    const hasData = data?.some(indicador =>
        meses.some(mes => indicador[mes] !== null && indicador[mes] !== undefined)
    );

    useEffect(() => {
        if (!data || data.length === 0 || !hasData) return;

        if (myChartRef.current) {
            myChartRef.current.destroy();
        }

        const datasets = data.map((indicador, index) => {
            const color = `hsl(${(index * 50) % 360}, 70%, 50%)`;
            return {
                label: indicador.indicador_nombre,
                tipo: indicador.tipo_indicador, // incluir tipo en el dataset
                data: meses.map(m => indicador[m] !== null ? Number(indicador[m]) : null),
                borderColor: color,
                backgroundColor: color,
                tension: 0.3,
                spanGaps: true,
                datalabels: {
                    align: 'top',
                    anchor: 'end',
                    formatter: (value) => value !== null ? value : ''
                }
            };
        });

        const ctx = chartRef.current.getContext('2d');
        myChartRef.current = new Chart(ctx, {
            type: 'line',
            data: {
                labels: etiquetasMeses,
                datasets
            },
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        display: true,
                        position: 'right',
                        align: 'top',
                        labels: {
                            boxWidth: 12,          // ✅ Reduce el tamaño del recuadro
                            padding: 8,            // ✅ Reduce espacio entre etiquetas
                            font: {
                                size: 10
                            },
                            usePointStyle: true    // ✅ Opcional: cambia cuadrados por círculos para más estética
                        }
                    },
                    datalabels: {
                        color: '#333',
                        font: {
                            size: 10
                        }
                    },
                    tooltip: {
                        callbacks: {
                            title: (tooltipItems) => {
                                // Mostrar el Mes
                                return `📅 ${tooltipItems[0].label}`;
                            },
                            label: (context) => {
                                const dataset = context.dataset;
                                const value = context.parsed.y !== null ? context.parsed.y : 'Sin dato';
                                return [
                                    `📊 Indicador: ${dataset.label}`,
                                    `🏷️ Tipo: ${dataset.tipo || 'N/A'}`,
                                    `📈 Resultado: ${value}`,
                                    '──────────────'
                                ];
                            }
                        }
                    }
                },
                scales: {
                    x: {
                        title: {
                            display: true,
                            text: 'Meses'
                        }
                    },
                    y: {
                        title: {
                            display: true,
                            text: 'Valor'
                        },
                        beginAtZero: true
                    }
                }
            }
        });

        return () => {
            if (myChartRef.current) {
                myChartRef.current.destroy();
            }
        };
    }, [data, hasData]);

    return (


        <div
            style={{
                position: 'relative',
                height: '100%',
                width: '100%',
                minHeight: '500px',      // ✅ altura mínima visible
                maxHeight: '600px',      // ✅ altura máxima controlada
                display: 'flex', alignItems: 'center', justifyContent: 'center'
            }}
        >

            {
                (!data || data.length === 0 || !hasData) ? (
                    <p style={{ textAlign: 'center', color: '#555' }}>
                        No se han registrado datos para este indicador. <br />
                        Registre datos para visualizar el gráfico.
                    </p>
                ) : (
                    <canvas ref={chartRef} />

                )
            }
        </div >
    );
};

export default IndicadoresLineChart;
